'use client';

import Link from 'next/link';
import type { NavigationItem } from '@/components/Header/links';
import styles from './navigationMenu.module.scss';
import NavigationSubMenu from './components/NavigationSubMenu';

type NavigationMenuProps = {
  navItems: NavigationItem[];
};

export default function NavigationMenu({ navItems }: NavigationMenuProps) {
  return (
    <nav className={styles.navigationMenu}>
      {navItems.map((link) => {
        if ('href' in link) {
          return (
            <Link
              className={`${styles.link} ${styles.linkHover}`}
              key={link.href}
              href={link.href}
              target={link.newTab ? '_blank' : undefined}
              rel={link.newTab ? 'noopener noreferrer' : undefined}
            >
              {link.title}
            </Link>
          );
        } else if (Array.isArray(link.sections)) {
          return (
            <NavigationSubMenu
              key={link.title}
              sections={link.sections}
              title={link.title}
              featured={link.feature}
            />
          );
        }
      })}
    </nav>
  );
}
